import React, { useEffect, useRef, useState } from 'react';
import Header from './Header';
import Footer2 from './Footer2';

const timelineData = [
    { year: "2010", text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt." },
    { year: "2015", text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt." },
    { year: "2020", text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt." },
    { year: "2024", text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt." },
];

const Bio = () => {
    const containerRef = useRef(null);
    const [visibleItems, setVisibleItems] = useState([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    const index = Number(entry.target.getAttribute('data-index'));
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            setVisibleItems(prev => {
                                if (!prev.includes(index)) return [...prev, index];
                                return prev;
                            });
                        }, 200);
                    }
                });
            },
            { threshold: 0.4 }
        );

        return () => observer.disconnect();
    }, []);

    return (
        <>
            {/* header part start  */}
            <Header />
            {/* header part end  */}

            <div className="bio1-main">
                <div className="container">
                    <div className="bio1-inner-main">
                        <div className="bio1-child">
                            <div className="bio1-inner-child">
                                <p className='bio1-one'>Professionally an interior designer, Vibha is a passionate self-taught artist, specializing in multiple artforms including pyrography, glass painting,resin art, and alcohol ink art. Starting out with hobby, Vibha went beyond the standard drawing and painting and learned novel artforms to create masterpieces that signify a core moment in people's lives.
                                </p>
                            </div>
                        </div>
                        <div className="bio1-child">
                            <div className="bio1-inner-child">
                                <img src="assets/img/sample.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="bio2-main">
                <div className="container">
                    <div className="bio2-inner-main">
                        <div className="bio2-child">
                            <div className="bio2-inner-child">
                                <img src="assets/img/Group.png" alt="" />
                            </div>
                        </div>
                        <div className="bio2-child">
                            <div className="bio2-inner-child">
                                <p className='bio2-one'>"I believe that we should decorate our places with memories, not objects. That's why I help you bring home a memory created with items that you provide to represent your key life moments."
                                    <span className='bio2-two'> - Vibha</span>
                                    <br /> <br />

                                    Vibha's art projects include variety of objects, from keychains and bookmarks to wedding portraits and office decorations, bringing joy to 230+ customers. Her work has been featured in multiple exhibitions in different cities. Check out her portfolio at VV creation studio and follow her Instagram to stay up to date with her work.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer2 />
        </>
    );
};

export default Bio;
